import * as SagasType from '../constants/constant_saga_types';
// import * as ActionType from '../constants/constant_action_types';

export function fetchDropdown(params) {
  const { type } = params;
  return { type: `${SagasType.FETCH_DROPDOWN}.${type}`, params };
}

/**
 * Make the dropdown fetch its list again. Optional filters can be
 * provided on the params parameter.
 *
 * @param {string} formId - the form where the dropdown appears
 * @param {object} params - contains "field" and "filter". Example:
 *  {
 *    location: { // the dropdown type
 *      {
 *        field: 'location_field',  // this should be a dropdown form field name that will be refreshed
 *        filter: { $and: [] }      // couchdb selector conditions used as filter on the query
 *      }
 *    }
 *  }
 */
export function refreshFormDropdown(formId, params) {
  return { type: SagasType.REFRESH_DROPDOWN, formId, params };
}

/** Integration */

export function saveIntegrationApp(data) {
    return { type: SagasType.SAVE_INTEGRATION_APP, data };
}

export function fetchIntegrationAppList(filters, silent) {
  return { type: SagasType.FETCH_LIST_INTEGRATION_APP, filters, silent };
}

export function getIntegrationAppForEdit(id) {
  return { type: SagasType.FETCH_INTEGRATION_APP_FOR_EDIT, id };
}

export function deleteIntegrationApp(id, fromList) {
  return { type: SagasType.DELETE_INTEGRATION_APP, id, fromList };
}

export function regenerateAppSecret(id) {
  return { type: SagasType.REGENERATE_INTEGRATION_APP_SECRET, id };
}


/* CSV import */
export function startCsvImport(id, reference_id) {
  return { type: SagasType.START_CSV_IMPORT, id, reference_id };
}
export function stopCsvImport(id) {
  return { type: SagasType.STOP_CSV_IMPORT, id };
}